import React from "react";
import { AppBar, Toolbar, Box } from "@mui/material";
 
// ✅ import image
import logo from "../assets/logo.png";
 
export default function Header() {
  return (
    <AppBar
      position="sticky"
      elevation={1}
      sx={{
        bgcolor: "#e18544"
      }}
    >
      <Toolbar
        sx={{
          justifyContent: "flex-start"
        }}
      >
        <Box
          component="img"
          src={logo}   // ✅ using imported image
          alt="Mealno Logo"
          sx={{
            height: 30,
            width: "auto",
            objectFit: "contain"
          }}
        />
      </Toolbar>
    </AppBar>
  );
}
 